import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import {
  createEmailConfirmation,
  confirmEmailWithCode,
  createPhoneConfirmation,
  confirmPhoneWithCode,
} from '../Auth.actions'

import ConfirmationCodeFormComponent from './ConfirmationCodeForm'

const formName = 'confirmationCodeForm'

const stateToProps = ({ auth: { user }, auth, form }, { type, recipient }) => ({
  confirmation: type === 'email' ? user.emailConfirmation : user.phoneConfirmation,
  delay: type === 'email' ? auth.emailConfirmationDelay : auth.phoneConfirmationDelay,
  loading: type === 'email' ? auth.emailConfirmationLoading : auth.phoneConfirmationLoading,
  verifying: type === 'email' ? auth.emailVerifying : auth.phoneVerifying,
  usernameIsChanging: type === 'email' && recipient !== user.username,
  disableSubmit: !form[formName]?.values?.code,
})

const dispatchToProps = {
  createEmailConfirmation,
  confirmEmailWithCode,
  createPhoneConfirmation,
  confirmPhoneWithCode,
}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    form: formName,
  })(ConfirmationCodeFormComponent)
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/ConfirmationCodeForm/ConfirmationCodeForm.container.js